import {
  Component,
  ViewEncapsulation
} from '@angular/core';


@Component({
  selector: 'mdl-layout-spacer',
  host: {
    '[class.mdl-layout-spacer]': 'true'
  },
  template: '',
  encapsulation: ViewEncapsulation.None
})
export class MdlLayoutSpacerComponent {}



// WEBPACK FOOTER //
// ./src/lib/components/layout/mdl-layout-spacer.component.ts